import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle'; 
import { ToastContainer, toast } from 'react-toastify';

function PackingMaster(props) {
  const [packingItems, setPackingItems] = useState([]);
  const [packingCode, setPackingCode] = useState('');
  const [packingName, setPackingName] = useState('');
  const [conversionFactor, setConversionFactor] = useState('');
   
  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  
  const [formMode, setFormMode] = useState('add');
  const [editPackingId, setEditPackingId] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [packingMasterEntries, setPackingMasterEntries] = useState([]);

 const [deleteEntryNo, setDeleteEntryNo] = useState(null);
    const [openConfirmation, setOpenConfirmation] = useState(false); 

  useEffect(() => {
    fetchPackingMaster();
  }, []);

  const fetchPackingMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/packing');
      setPackingMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1; 
      setPackingCode(nextEntryNo);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const calculateMaxEntryNo = (entries) => {
  let maxEntryNo = 0;
  for (const entry of entries) {
  if (entry.PackingCode > maxEntryNo) {
  maxEntryNo = entry.PackingCode;
  }
  }
  return maxEntryNo;
  };

  const addPackingItem = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/packing', {
        PackingCode: packingCode,
        PackingName: packingName,
        ConversionFactor: conversionFactor,
        USERID: props.name
      });
      fetchPackingMaster();
      setPackingCode('');
      setPackingName('');
      setConversionFactor('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updatePackingItem = async (PackingCode) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/packing/${PackingCode}`, {
        PackingCode: packingCode,
        PackingName: packingName,
        ConversionFactor: conversionFactor,
        USERID: props.name
      });
      fetchPackingMaster();
      setPackingCode('');
      setPackingName('');
      setConversionFactor('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  }; 

    const handleDeleteConfirmation = async () => {
      try {
        if (deleteEntryNo) {
          await deletePackingItem(deleteEntryNo.PackingCode);
          setOpenConfirmation(false);
        }
      } catch (error) {
        console.log('Error:', error);
      }
    };

  const deletePackingItem = async (PackingCode) => {
    if (!props.canDelete) {
              toast.error("You do not have permission to Delete.", { autoClose: 800 });
              return;
            }
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/packing/${PackingCode}`, {
        headers: {
          'username': props.name,
        },
      });
      if (response.status === 200) {
        fetchPackingMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  };

  const setEditForm = (packingItem) => {
    setFormMode('edit');
    setPackingCode(packingItem.PackingCode);
    setPackingName(packingItem.PackingName);
    setConversionFactor(packingItem.ConversionFactor);
    setShowGrid(false);
  };

  const handleSearch = (searchQuery) => {
    const filtered = packingItems.filter((packingItem) => {
      const PackingCode = packingItem.PackingCode.toString().toLowerCase();
      const PackingName = packingItem.PackingName.toString().toLowerCase();
      const ConversionFactor = packingItem.ConversionFactor.toString().toLowerCase();

      return (
        PackingCode.includes(searchQuery.toLowerCase()) ||
        PackingName.includes(searchQuery.toLowerCase()) ||
        ConversionFactor.includes(searchQuery.toLowerCase())
      );
    });

    setPackingMasterEntries(filtered);
  };

  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, packingItems]);

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setPackingItems(packingItems);
  };

  const handleCancel = () => {
    setFormMode('add');
    setEditPackingId('');
    setPackingCode('');
    setPackingName('');
    setConversionFactor('');
  };

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "PackingData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
      <ToastContainer/>
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>PackingMaster</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
        >
          {showGrid ? 'Add' : 'Back'}
        </Button>
      </Grid>
      {showGrid && <Grid item>
        <Button
          variant="contained"
          onClick={generatePDF}
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Download PDF
        </Button>
      </Grid>}
      {showGrid && <Grid item>
        <Button
          variant="contained"
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Export
        </Button>
      </Grid>}
      {!showGrid && (
        <>
        <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="packingCode" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>PackingCode</label>
            <input
              type="text"
              value={packingCode}
              readOnly
              placeholder="PackingCode"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="packingName" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>PackingName</label>
            <input
              type="text"
              value={packingName}
              onChange={(e) => setPackingName(e.target.value)}
              placeholder="PackingName"
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="conversionFactor" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>ConversionFactor</label>
            <input
              type="text"
              value={conversionFactor}
              onChange={(e) => setConversionFactor(e.target.value)}
              placeholder="ConversionFactor"
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            />
          </div>
        </div>
        <div>
          <button
            className={formMode === 'add' ? 'add-button' : 'update-button'}
            onClick={formMode === 'add' ? addPackingItem : () => updatePackingItem(packingCode)}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
          >
            {formMode === 'add' ? 'Add' : 'Update'}
          </button>
          <button
            className="view-button"
            onClick={handleCancel}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginLeft: '10px',
              marginBottom: '10px',
            }}
          >
            Cancel
          </button>
        </div>
      </>      
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <h2>Entries</h2>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  PackingCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  PackingName
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  ConversionFactor
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                  className="print-hide"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {packingMasterEntries.sort((a, b) => {
                    if (a.PackingCode > b.PackingCode) return -1;
                    if (a.PackingCode < b.PackingCode) return 1;
                    return 0;
                  }).map((packingItem) => (
                <tr key={packingItem.PackingCode} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{packingItem.PackingCode}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc', textAlign:'left' }}>{packingItem.PackingName}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc', textAlign:'right' }}>{packingItem.ConversionFactor}</td>
                  <td className="print-hide" style={{ border:'1px solid #ccc' }}>
                    <button
                     className='action-btn btn-edit'
                      onClick={() => setEditForm(packingItem)}
                    >
                      Edit
                    </button>
                    <button
                     className='action-btn btn-delete'
                      onClick={() => {
                        setDeleteEntryNo({PackingCode: packingItem.PackingCode});
                        setOpenConfirmation(true); 
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center'}} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{fontSize:'16px'}} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar> 

          <Dialog
            open={openConfirmation}
            onClose={() => setOpenConfirmation(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to DELETE ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                Cancel
              </Button>
              <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                DELETE
              </Button>
            </DialogActions>
          </Dialog>           
    </div>
  );
}

export default PackingMaster;
